export const version = '2.8.5';
export const name = 'js-libp2p';
//# sourceMappingURL=version.js.map